export const IS_EQUAL_PROMINENCE_META = "PRIME_TITANS53";
export const IS_EQUAL_PROMINENCE_MOBILE_META = "PRIME_TITANS374";
export const EQUAL_PROMINENCE_FLIGHT_SUMMARY_MOBILE = "PRIME_TITANS361M";
export const IS_RETAIL_TECHNIQUE_ACTIVE_MOBILE = "PRIME_TITANS40M";
export const IS_RETAIL_TECHNIQUE_ACTIVE_DESKTOP = "PRIME_TITANS40D";
export const IS_QUICK_ADD_PRIME_META = "PRIME_TITANS135";
export const QUICK_ADD_PRIME_META_V2 = "PRIME_TITANS5733";
export const IS_REVERSE_PSYCHOLOGY_SKYSCANNER_PARTNERS = "PRIME_TITANS328";
export const PRIME_DAYS_BANNER_FLIGHT_SUMMARY_MOBILE = "PRIME_TITANS319";
export const TRUST_PILL_ENABLED = "PRIME_TITANS410";
export const ROTATION_PRIME_BENEFITS_ENABLED = "PRIME_TITANS473";
export const DUALDISPLAY_META_V2 = "PRIME_TITANS570M";
export const IS_CONFIRMATION_WIDGET_FOR_FRENCH_META = "PRIME_TITANS608";
export const PRIME_TITANS_MONEY_BACK_GUARANTEE = "PRIME_TITANS601";
export const IS_QUICK_ADD_PRIME_META_FOR_PARTNERS = "PRIME_TITANS10602";
export const FREE_TRIAL_REASSURANCE = "PRIME_TITANS10855";
export const IS_PRIME_WIDGET_RETAIL_TECHNIQUE = "PRIME_TITANS10785";
export const IS_PRIME_WIDGET_RETAIL_TECHNIQUE_MOBILE = "PRIME_TITANS697";
export const BENEFITS_REVAMP_LAYOUT_META = "PRIME_TITANS11096";
export const IS_PRIME_WIDGET_AVERSION_TECHNIQUE = "PRIME_TITANS760";

export const titansAliases = {
  isEqualProminenceMeta: IS_EQUAL_PROMINENCE_META,
  isEqualProminenceMobileMeta: IS_EQUAL_PROMINENCE_MOBILE_META,
  isRetailTechniqueActiveMobile: IS_RETAIL_TECHNIQUE_ACTIVE_MOBILE,
  isRetailTechniqueActiveDesktop: IS_RETAIL_TECHNIQUE_ACTIVE_DESKTOP,
  isQuickAddPrime: IS_QUICK_ADD_PRIME_META,
  isQuickAddPrimeV2: QUICK_ADD_PRIME_META_V2,
  isReversePsychologySkyscannerPartners:
    IS_REVERSE_PSYCHOLOGY_SKYSCANNER_PARTNERS,
  isPrimeDaysBanner: PRIME_DAYS_BANNER_FLIGHT_SUMMARY_MOBILE,
  isEqualProminenceSummaryMobile: EQUAL_PROMINENCE_FLIGHT_SUMMARY_MOBILE,
  isTrustPillEnabled: TRUST_PILL_ENABLED,
  isRotationPrimeBenefitsEnabled: ROTATION_PRIME_BENEFITS_ENABLED,
  isDualDisplayMetaV2: DUALDISPLAY_META_V2,
  isConfirmationWidgetForFrenchMeta: IS_CONFIRMATION_WIDGET_FOR_FRENCH_META,
  isMoneyBackGuarantee: PRIME_TITANS_MONEY_BACK_GUARANTEE,
  isQuickAddPrimeForPartners: IS_QUICK_ADD_PRIME_META_FOR_PARTNERS,
  isFreeTrialReassurance: FREE_TRIAL_REASSURANCE,
  isPrimeWidgetRetailTechnique: IS_PRIME_WIDGET_RETAIL_TECHNIQUE,
  isPrimeWidgetRetailTechniqueMobile: IS_PRIME_WIDGET_RETAIL_TECHNIQUE_MOBILE,
  benefitsRevampLayout: BENEFITS_REVAMP_LAYOUT_META,
  isPrimeWidgetAversionTechnique: IS_PRIME_WIDGET_AVERSION_TECHNIQUE,
};

export const aliases = Object.values(titansAliases);
